import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from "@material-ui/core";
import { CustomTableRow } from "./custom-table-row/CustomTableRow";
import { TableState } from "../../states/TableState";
import { Paginator } from "../paginator/Paginator";
import "./CustomTable.scss";

export class CustomTable extends React.Component<any, TableState> {
  private rowsPerPage: number;
  private headerLabels: Array<string>;
  constructor(props: any) {
    super(props);

    this.state = {
      page: 0,
      data: props.data ?? [],
      count: (props.data ?? []).length,
      show: false,
    };

    this.rowsPerPage = props.rowsPerPage ?? 10;
    this.headerLabels = props.headerLabels ?? [];
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleFirstPageButtonClick = this.handleFirstPageButtonClick.bind(this);
    this.handlePrevPageButtonClick = this.handlePrevPageButtonClick.bind(this);
    this.handleNextPageButtonClick = this.handleNextPageButtonClick.bind(this);
    this.handleLastPageButtonClick = this.handleLastPageButtonClick.bind(this);
  }

  componentDidUpdate(prevProps: Readonly<any>): void {
    if (prevProps.data !== this.props.data) {
      this.setState({
        page: 0,
        data: this.props.data,
        count: (this.props.data ?? []).length,
      });
    }
  }

  handleChangePage = (event: any, newPage: number) => {
    this.setState({ page: newPage });
  };

  handleFirstPageButtonClick(): void {
    this.setState({ page: 0 });
    this.setState((prevState) => ({ show: !prevState.show }));
  }

  handlePrevPageButtonClick(): void {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
    this.setState((prevState) => ({ show: !prevState.show }));
  }

  handleNextPageButtonClick(): void {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
    this.setState((prevState) => ({ show: !prevState.show }));
  }

  handleLastPageButtonClick(): void {
    this.setState({ page: Math.ceil(this.state.count / this.rowsPerPage) - 1 });
    this.setState((prevState) => ({ show: !prevState.show }));
  }

  render() {
    return (
      <>
        <TableContainer className="custom-table-container" component={Paper}>
          <Paginator
            data={this.state.data}
            page={this.state.page}
            count={this.state.count}
            rowsPerPage={this.rowsPerPage}
            handleChangePage={this.handleChangePage}
            handleFirstPageButtonClick={this.handleFirstPageButtonClick}
            handlePrevPageButtonClick={this.handlePrevPageButtonClick}
            handleNextPageButtonClick={this.handleNextPageButtonClick}
            handleLastPageButtonClick={this.handleLastPageButtonClick}
          />
          <div className="table-wrapper">
            <Table className="custom-table">
              <TableHead>
                <TableRow className="custom-table-header">
                  {this.props.isCheckable ? (
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={this.props.numSelected > 0 && this.props.numSelected < this.props.rowCount}
                        checked={this.props.rowCount > 0 && this.props.numSelected === this.props.rowCount}
                        onChange={this.props.onSelectAllClick}
                      />
                    </TableCell>
                  ) : null}
                  {this.headerLabels.map((label) => (
                    <TableCell className="custom-table-header-label">{label}</TableCell>
                  ))}
                  {this.props.isCollapsable ? (
                    <TableCell></TableCell>
                  ) : null}
                  {this.props.isCallToAction ? (
                    <TableCell></TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.data && this.state.data.length > 0 && this.state.data.slice(this.state.page * this.rowsPerPage, this.state.page * this.rowsPerPage + this.rowsPerPage).map((row) => (
                  <CustomTableRow
                    row={row}
                    // HERE: collapsable row props
                    isCollapsable={this.props.isCollapsable}
                    collapseLabel={this.props.collapseLabel}
                    // HERE: call to action props
                    isCallToAction={this.props.isCallToAction}
                    ctaLabel={this.props.ctaLabel}
                    ctaOnClick={this.props.ctaOnClick}
                    // HERE: checkbox
                    isCheckable={this.props.isCheckable}
                    onSelectRow={this.props.onSelectRow}
                    rowSelected={this.props.rowSelected && this.props.rowSelected.indexOf(row.merchantId) !== -1}
                    showAccordion={this.state.show}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
        </TableContainer>
      </>
    );
  }
}
